import {
    Stack,
    Divider,
    Heading
} from '@chakra-ui/react'

const TextDivider = ({ label }) => {
    return (
        <Stack display={'inline-flex'} direction={'row'} align={'center'} justify={'center'}>
            <Heading fontSize={'2xl'}>{label}</Heading>
            <Divider flex={'1'} ml={'2'} borderColor={'gray.400'} />
        </Stack>
    )
}

export default TextDivider